import type { TourStep } from '../types';

export const managingInquiriesSteps: TourStep[] = [
  {
    target: '[data-tour="leads-header"]',
    title: 'Your Leads Inbox',
    content:
      'When clients submit requests through your public website, their inquiries land here. The badge shows unread count.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="leads-tabs"]',
    title: 'Inquiry Types',
    content:
      'Website inquiries are appraisal requests. If you supervise trainees, you\'ll also see a "Trainee Interest" tab for those applications.',
    placement: 'bottom',
    spotlightClicks: true,
  },
  {
    target: '[data-tour="leads-filters"]',
    title: 'Search & Filter',
    content:
      'Search by name, email, or property address. Use the status dropdown to filter by New, Contacted, Quote Sent, Converted, or Archived. Try filtering by status.',
    placement: 'bottom',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'Got it',
  },
  {
    target: '[data-tour="leads-table"]',
    title: 'Inquiry List',
    content:
      'Each row shows the contact, property details, status, and date received. Unread inquiries have a blue dot. Click any row to see full details.',
    placement: 'top',
    spotlightClicks: true,
  },
  {
    target: '[data-tour="leads-actions"]',
    title: 'Take Action',
    content:
      'From the actions menu you can mark as read, update status, convert to an appraisal or engagement letter, or archive. Try opening the menu on an inquiry.',
    placement: 'left',
    isActionStep: true,
    spotlightClicks: true,
  },
];
